import { Box, Center, Link, VStack } from '@chakra-ui/react'
import { UserLoginForm } from '@src/components/sco/Account/UserLoginForm'
import { Paragraph } from '@src/components/sco/Paragraph.tsx'
import { NextLink } from '@src/components/sco/utilities/NextLink'
import { SEOMetadata } from '@src/components/sco/utilities/SEOMetadata'
import { SIGNUP_PATHS } from '@src/constants/navigation'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import { PageWithNavBar } from '@src/templates/PageWithNavBar'
import { useSearchParams } from 'next/navigation'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default function Page() {
  const queryParams = useSearchParams()
  const activeContent = useActiveContentContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection?.('login')
  })

  return (
    <PageWithNavBar>
      <Center minH={'80vh'} width={'full'}>
        <VStack gap={4} maxWidth={'container.sm'} paddingY={4} width={'full'}>
          <Box width={'full'}>
            <UserLoginForm
              loginMethod={`${queryParams.get('loginMethod') || 'token'}`}
              returnToHref={`${queryParams.get('returnTo') || '/account'}`}
              title={'Login'}
            />
          </Box>
          <Box textAlign={'center'} width={'full'}>
            <Paragraph fontSize={'sm'}>
              New here?
              <Link asChild marginLeft={'0.5em'} variant={'underline'}>
                <NextLink href={SIGNUP_PATHS.register}>Create an Account</NextLink>
              </Link>
            </Paragraph>
          </Box>
        </VStack>
      </Center>
      <SEOMetadata title={'Login'} />
    </PageWithNavBar>
  )
}
